var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMfaEnabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 9.14286C11.6876 9.14286 11.939 9.17333 12.1905 9.21143V6.85714C12.1905 6.01905 11.5124 5.33333 10.6667 5.33333H9.90476V3.80952C9.90476 1.70667 8.19809 0 6.09524 0C3.99238 0 2.28571 1.70667 2.28571 3.80952H3.80952C3.80952 2.54476 4.83048 1.52381 6.09524 1.52381C7.36 1.52381 8.38095 2.54476 8.38095 3.80952V5.33333H1.52381C0.678095 5.33333 0 6.01905 0 6.85714V14.4762C0 15.3143 0.678095 16 1.52381 16H7.47429C7.08571 15.3295 6.85714 14.5524 6.85714 13.7143C6.85714 11.1924 8.90667 9.14286 11.4286 9.14286ZM6.09524 12.1905C5.25714 12.1905 4.57143 11.5124 4.57143 10.6667C4.57143 9.82095 5.25714 9.14286 6.09524 9.14286C6.93333 9.14286 7.61905 9.82857 7.61905 10.6667C7.61905 11.5048 6.94095 12.1905 6.09524 12.1905ZM14.0952 12.381L10.4762 16L8.38095 13.7143L9.26476 12.8305L10.4762 14.0419L13.2114 11.3067L14.0952 12.381Z",
    fill: "#525E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfaEnabled);
export default __webpack_public_path__ + "static/media/mfa_enabled.c7a8caf41b6b62f670cf730d05942d58.svg";
export { ForwardRef as ReactComponent };